const initialState=[
    {
      'id': '1',
      'urn': 'ndocs',
      'itemname': 'Нормативные документы',
      'ids':'8',
    },

    {
      'id': '2',
      'urn': 'requests',
      'itemname': 'Заявки',
      'ids':'6',
    },

    {
      'id': '3',
      'urn': 'instructions',
      'itemname': 'Инструкции по настройке',
      'ids':'9',
    },
    {
      'id': '4',
      'urn': 'contacts',
      'itemname': 'Контакты',
      'ids':'9',
    },
    {
    'id': '5',
    'urn': 'services',
    'itemname': 'Коммерческие услуги',
    'ids':'9',
    },



]




export default function menuitems(state = initialState, action) {

  return state;


}
